import Layer from '@mozaic-ds/freemarker/js/modules/_layer.js';
export const getTmsInstance = () => {
  return window['tms'];
};
class AddToShoppingList extends lm.Composant {
  constructor(id) {
    super(id);
    this.PARAMS = {
      OPEN_LAYER: 'isOpenShoppinglistPopin',
      QUANTITY: 'withQuantity'
    };
    this.quantity = 1;
    this.button = document.querySelector(".js-shopping-list-button");
    try {
      const offerFormElement = document.querySelector("form.js-add-to-cart-pdp-form");
      if (offerFormElement) {
        this.refLm = offerFormElement.querySelector("input[name='reflm']").value;
        this.offerId = offerFormElement.querySelector("input[name='offerId']").value;
        this.quantitySelectorElement = offerFormElement.querySelector("input[name='quantity']");
      }
    } catch (error) {
      throw new Error(error);
    }
    this.button.addEventListener('click', e => this.addParamsToReferer(e));
    if (window.location.search.includes(this.PARAMS.QUANTITY)) {
      const searchParams = new URLSearchParams(window.location.search);
      this.quantity = searchParams.get(this.PARAMS.QUANTITY);
    }
    if (this.button && !!window.location.search.includes(`${this.PARAMS.OPEN_LAYER}=true`)) {
      this.selectListModal = new Layer({
        "classContent": "js-select-list-modal"
      });
      this.selectListModal.content = this.selectListModal.layer.querySelector('.mc-layer__body');
      this.selectListModal.button = this.selectListModal.layer.querySelector('.js-select-list-modal-button');
      this.resultModal = new Layer({
        "classContent": "js-result-modal"
      });
      this.resultModal.content = this.resultModal.layer.querySelector('.mc-layer__body');
      this.errorMessage = window.addtoshoppinglist?.translation?.errorText ?? "Unknown error occurred";
      this.getShoppingList();
    }
  }

  /**
  * Edit href button to add params
  */
  addParamsToReferer(e) {
    e.preventDefault();
    const url = new URL(this.button.formAction);
    let refererValue = url.searchParams.get('referer');
    refererValue += encodeURI(`?${this.PARAMS.OPEN_LAYER}=true`);
    if (this.quantitySelectorElement) {
      refererValue += encodeURI(`&${this.PARAMS.QUANTITY}=${this.quantitySelectorElement.value}`);
    }
    url.searchParams.set('referer', refererValue);
    window.location = url;
  }

  /**
   * HTTP request to retrieve existing shopping lists
   */
  getShoppingList() {
    lm.fetch({
      url: "/shoppinglist/services/list",
      method: "GET",
      headers: new Headers({
        "referer": window.document.location,
        "Content-Type": "application/json;charset=UTF-8"
      }),
      success: response => {
        this.selectListModal.content.innerHTML = response;
        const el = this.selectListModal.layer.querySelector('.js-select-list-modal-radio input[type="radio"]:checked');
        this.radiosRules(el);
        this.watchFormChanges();
      },
      error: error => {
        this.selectListModal.content.innerHTML = this.errorMessage;
        console.error(error);
      },
      complete: () => {
        this.selectListModal.open();
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    });
  }
  radiosRules(el) {
    this.selectListModal.radios = this.selectListModal.layer.querySelectorAll('.js-select-list-modal-radio input[type="radio"]');
    this.selectListModal.input = this.selectListModal.layer.querySelector('.js-select-list-modal-input');
    this.selectListModal.listName = this.selectListModal.layer.querySelectorAll('.js-select-list-modal-radio label');
    this.selectListModal.errorMsg = this.selectListModal.layer.querySelector('.js-error-same-name');
    if (el.target === this.selectListModal.radios[this.selectListModal.radios.length - 1]) {
      this.isNewList = true;
      this.selectListModal.input.focus();
      this.selectListModal.button.disabled = this.selectListModal.input.value.length === 0;
      this.listId = null;
    } else {
      this.isNewList = false;
      this.selectListModal.input.value = "";
      this.selectListModal.button.disabled = [...this.selectListModal.radios].filter(radio => radio.checked).length === 0;
      this.listId = [...this.selectListModal.radios].find(radio => radio.checked).value;
      this.listName = null;
    }
  }

  /**
   * Look at the changes on the form to determine if we are in the case of
   * a choice of an existing list or if we need to create a new shopping list
   * @return void
   */
  watchFormChanges() {
    const lists = [...this.selectListModal.listName].map(o => o.innerHTML.trim());
    this.selectListModal.radios.forEach(radio => {
      radio.addEventListener("change", el => this.radiosRules(el));
    });
    this.selectListModal.input.addEventListener("keyup", () => {
      this.isNewList = true;
      this.selectListModal.radios[this.selectListModal.radios.length - 1].checked = true;
      this.selectListModal.button.disabled = this.selectListModal.input.value.length === 0;
      this.listName = this.selectListModal.input.value;
      this.selectListModal.errorMsg.classList.toggle('kl-hidden', !lists.includes(this.listName));
      this.selectListModal.input.classList.toggle('is-invalid', lists.includes(this.listName));
      this.selectListModal.button.disabled = lists.includes(this.listName);
      this.listId = null;
    });
    this.selectListModal.button.addEventListener("click", () => this.prepareDataAndSend());
  }

  /**
   * preparation of the body before sending to the post
   */
  prepareDataAndSend() {
    const data = {
      'listId': this.listId,
      'listName': this.listName,
      'product': {
        'refLm': this.refLm,
        'quantity': this.quantity,
        'offerId': this.offerId
      }
    };
    this.postProductInShoppingList(data);
  }

  /**
   * Adding a product to a shopping list
   * @param  {data: object} data - body for post with refLm / quantity / listId (add in existing list) or listname (for create a new list)
   */
  postProductInShoppingList(data) {
    lm.fetch({
      url: "/shoppinglist/services/addProduct",
      method: "POST",
      headers: new Headers({
        "referer": window.document.location,
        "Content-Type": "application/json;charset=UTF-8"
      }),
      body: JSON.stringify(data),
      success: result => {
        this.resultModal.content.innerHTML = result;
        this.resultModal.layer.querySelector(".js-layer-first-cta").href = this.resultModal.content.querySelector("input[name='listUrl']").value;
        lm.lazyload.observe();
        if (data.listName && data.listName !== "") {
          this.trackNewShoppingList();
        } else {
          this.trackAddProductInShoppingList();
        }
      },
      error: error => {
        this.resultModal.content.innerHTML = this.errorMessage;
        console.error(error);
      },
      complete: () => this.resultModal.open()
    });
  }

  /**
   * Sending a tracking event when creating a new shopping list
   */
  trackNewShoppingList() {
    getTmsInstance().pushEvent(this.selectListModal.button, 'cdl_event', {
      'event_name': 'product.add_to_wishlist',
      'event_data': {
        'product_id': this.refLm,
        'wishlist_isdefault': false
      }
    });
    getTmsInstance().pushEvent(this.selectListModal.button, 'cdl_event', {
      'event_name': 'wishlist.creation',
      'event_data': {
        'wishlist_creation_method': 'pdp',
        'wishlist_isdefault': false
      }
    });
  }

  /**
   * Sending a tracking event when adding a product to an existing shopping list
   */
  trackAddProductInShoppingList() {
    getTmsInstance().pushEvent(this.selectListModal.button, 'cdl_event', {
      'event_name': 'product.add_to_wishlist',
      'event_data': {
        'product_id': this.refLm,
        'wishlist_isdefault': true
      }
    });
  }
}
lm.DOMReady(function () {
  new AddToShoppingList("addtoshoppinglist");
});